var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDriver(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    fill: "currentColor",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.jasldkfkladslkajdkjlkjasdhfhasdfhalkshfjdalhfjlasdhfkahsdkfhlad{fill:none;stroke:currentColor;stroke-width:32;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "jasldkfkladslkajdkjlkjasdhfhasdfhalkshfjdalhfjlasdhfkahsdkfhlad",
    d: "M469.1,491H46.4c0,0-34.8-209.7,114.4-226.5c0,0,38.1,65,98.7,65c0,0,62.8,2.2,92-65 c0,0,124.5-1.1,115.5,176.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "jasldkfkladslkajdkjlkjasdhfhasdfhalkshfjdalhfjlasdhfkahsdkfhlad",
    points: "397.4,371 321.1,371 321.1,420.4 397.4,420.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "jasldkfkladslkajdkjlkjasdhfhasdfhalkshfjdalhfjlasdhfkahsdkfhlad",
    d: "M265,281.3c0,0-121.1-78.5-112.1-157c0,0,2.2-107.7,109.9-103.2c0,0,100.9-4.5,100.9,105.4 c0,0,4.5,76.3-78.5,112.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriver);
export default __webpack_public_path__ + "static/media/driver.51fe50c73cc792dcc9af686fa389f485.svg";
export { ForwardRef as ReactComponent };